module.exports = __webpack_public_path__ + "img/theater_round_8.91e6f0fa.png";